import { memo } from 'react';
import { Button, Modal, ModalContent } from '@restworld/ui-ds-base';
import { useEditPhoneNumberForm } from '../../hooks/use-edit-phone-number-form';
import { useEnterPhoneNumberContent } from './enter-phone-number-content';
import { useValidateOtpContent } from './validate-otp-content';
import { useEditPhoneNumberSuccessfulContent } from './edit-phone-number-successful';
import { useAuthContext } from '@restworld/feature-authentication';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  initializePhoneNumberValidation,
  isEnterPhoneNumber,
  isValidateOtp,
  isVerificationSuccessful,
  // setInitializePhoneNumberValidation,
  setIsEnterPhoneNumber,
} from './states';
import { FlexCol } from '../header';
// import { BodyText } from '../account-settings-tab';
import { useTranslation } from 'next-i18next';

export const EditPhoneNumberModal = memo(() => {
  const authContext = useAuthContext();
  const phoneNumber = authContext?.user?.phone_number;
  // const isPhoneNumberVerified = authContext?.user?.phone_number_verified;
  const { onOpen, onClose, open } = useEditPhoneNumberForm();
  const setEnterPhoneNumberContent = useSetAtom(setIsEnterPhoneNumber);
  // const startVerifyPhoneNumber = useSetAtom(setInitializePhoneNumberValidation);
  const { t } = useTranslation('user-settings');

  const handleOpen = () => {
    setEnterPhoneNumberContent(true);
    onOpen();
    // if (isPhoneNumberVerified || !phoneNumber) {
    //   setEnterPhoneNumberContent(true);
    //   onOpen();
    // }

    // if (!isPhoneNumberVerified && phoneNumber) {
    //   startVerifyPhoneNumber(true);
    //   onOpen();
    // }
  };

  return (
    <>
      <FlexCol className="gap-2 lg:items-end items-start">
        <Button onClick={handleOpen} variant="tertiary" size="sm" className="whitespace-nowrap">
          {/* {!isPhoneNumberVerified && phoneNumber
            ? t('phone_number_modal_send_verification_code')
            : t('account_tab_edit_phone_number_button_text')} */}
          {t('account_tab_edit_phone_number_button_text')}
        </Button>
        {/* {!isPhoneNumberVerified && phoneNumber && (
          <BodyText>
            <span className="whitespace-nowrap">{t('phone_number_modal_verify_phone_number_prompt')}</span>
          </BodyText>
        )} */}
      </FlexCol>
      {open && <EditPhoneNumberModalContent open={open} onClose={onClose} phoneNumber={phoneNumber} />}
    </>
  );
});

export const EditPhoneNumberModalContent = memo(
  ({ open, onClose, phoneNumber }: { open: boolean; onClose: () => void; phoneNumber: string }) => {
    const verifyPhoneNumber = useAtomValue(initializePhoneNumberValidation);
    const isPhoneNumberOpen = useAtomValue(isEnterPhoneNumber);
    const showVerificationSuccessful = useAtomValue(isVerificationSuccessful);
    const showValidateOtp = useAtomValue(isValidateOtp);
    const { enterPhoneNumberContent, enterPhoneNumberFooter } = useEnterPhoneNumberContent({ phoneNumber });
    const { validateOtpContent, validateOtpFooter } = useValidateOtpContent({ phoneNumber });
    const { editPhoneNumberSuccessfulContent, editPhoneNumberSuccessfulFooter } = useEditPhoneNumberSuccessfulContent();

    const showEnterPhoneNumber = isPhoneNumberOpen || verifyPhoneNumber;

    const renderFooter = showVerificationSuccessful
      ? editPhoneNumberSuccessfulFooter
      : showValidateOtp
      ? validateOtpFooter
      : showEnterPhoneNumber
      ? enterPhoneNumberFooter
      : null;
    return (
      <Modal open={open} onOpenChange={(v) => !v && onClose()}>
        <ModalContent variant="center" className="lg:min-w-[31.75rem] lg:max-w-[31.75rem]" footer={renderFooter}>
          <div className="w-full pt-5">
            {showEnterPhoneNumber && enterPhoneNumberContent}
            {showValidateOtp && validateOtpContent}
            {showVerificationSuccessful && editPhoneNumberSuccessfulContent}
          </div>
        </ModalContent>
      </Modal>
    );
  }
);
